import Box from "@mui/material/Box";
import React, { useContext, useEffect, useState } from "react";
import { statusReasonActions } from "../../service/statusreason.actions";
import { StatusReasonMainTitle } from "./StatusReasonMainTitle";
import FileSaver from "file-saver";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import {
  AddNewStatusReasons,
  ValuesStatusReasonObject,
} from "./AddNewStatusReasons";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useTranslation } from "react-i18next";
import CustomLoader from "../../../../util/component/CustomLoader";
import { Card, Chip, IconButton, Typography } from "@mui/material";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { IServerSideGetRowsParams } from "ag-grid-community";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import BorderColorIcon from "@mui/icons-material/BorderColor";

import GenericFilterBox from "../common/GenericFilterBox";
import { ContextOperation } from "../../context/OperationContext";
import useTenant from "../../hooks/useTenant";
import EnumChangeName from "../common/EnumChangeName";
import SectionHeader from "../../../../util/component/SectionHeader";
import { useHasScope } from "../../../../config/globalConfig";
import EmptyStateGrid from "../common/EmptyStateGrid";
import AgGridOperationTable from "../common/AgGridOperationTable";


export const StatusReasonTable = () => {
  const hasScope = useHasScope;
  const { t } = useTranslation(["operation"]);
  const userStatusReason = statusReasonActions();
  const [pageSize, setPageSize] = useState<number>(10);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [length, setLength] = useState<number>(0);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [open, setOpen] = React.useState(false);
  const [openAddDialog, setOpenAddDialog] = React.useState(false);
  const [refreshTableByX, setRefreshTableByX] = useState(false);
  const [getIdForDelete, setGetIdForDelete] = useState<any>({});
  const { globalData, dispatchGlobalData } = useContext(GlobalContext);

  const [rowData, setRowData] = useState<any>([]);
  const [gridApi, setGridApi] = useState<any>(null);
  const [getStatusReasonDataForm, setStatusReasonDataForm] =
    useState<ValuesStatusReasonObject>({
      code: "",
      descr: "",
      status: "",
      valid: "",
      transferable: "",
      damages: "",
      id: "",
    });
  const { tenant } = useContext(ContextOperation);
  const { tenantOptions: options } = useTenant();

  const widthFunction = () => {
    if (
      hasScope("SCOPE_UPDATE_MDVEHICLE_STATUSREASON") ||
      hasScope("SCOPE_DELETE_MDVEHICLE_STATUSREASON")
    )
      return 100;
    else return 0;
  };

  const columnDefs: any = [
    { field: "descr", headerName: t("carRange.description"), flex: 1 },
    { field: "code", headerName: t("carRange.code"), flex: 1 },

    {
      field: "status",
      headerName: t("statusReason.status"),
      flex: 1,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.status}>
          <span>
            {params.data.status === "AVAILABLE"
              ? t("internOptionSelectName.available")
              : t("internOptionSelectName.notAvailable")}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "valid",
      headerName: t("statusReason.validity"),
      cellRenderer: (params: any) => {
        return (
          <Chip
            label={
              params.data.valid
                ? t("internOptionSelectName.valid")
                : t("internOptionSelectName.inValid")
            }
            color={params.data.valid ? "success" : "error"}
            variant="filled"
          />
        );
      },
    },
    {
      field: "transferable",
      headerName: t("statusReason.transferable"),
      flex: 1,
      cellRenderer: (params: any) => {
        return EnumChangeName().yesNoType(
          params.data?.transferable?.toString()
        );
      },
    },
    {
      field: "damages",
      headerName: t("statusReason.damages"),
      flex: 1,
      cellRenderer: (params: any) => {
        return EnumChangeName().yesNoType(params.data?.damages?.toString());
      },
    },

    {
      field: "action",
      headerName: "",
      maxWidth: widthFunction(),
      cellStyle: { "background-color": "neutral.bright" },
      cellRenderer: (params: any) => {
        const onClick = () => {
          setOpen(true);
          setGetIdForDelete(params.data);
        };
        return (
          <Box>
            {hasScope("SCOPE_UPDATE_MDVEHICLE_STATUSREASON") && (
              <Tooltip title={t("tooltipTitle.editShowAction")}>
                <IconButton
                  color="accent"
                  disabled={params.data.default}
                  onClick={() => openModalCreatEdit(params)}
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            )}

            {hasScope("SCOPE_DELETE_MDVEHICLE_STATUSREASON") && (
              <Tooltip title={t("tooltipTitle.delete")}>
                <IconButton
                  color="accent"
                  disabled={params.data.default}
                  onClick={onClick}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    },
  ];

  const openModalCreatEdit = (params: any) => {
    setGetIdForDelete(params.data);
    setStatusReasonDataForm({
      code: params.data.code,
      descr: params.data.descr,
      status: params.data.status,
      damages: params.data.damages,
      valid: params.data.valid,
      transferable: params.data.transferable,
      id: params.data.id ? params.data.id : null,
    });
    setOpenAddDialog(true);
  };

  const createOrEditStatusReason = (promoIncreaseObject: any) => {
    if (promoIncreaseObject.id) {
      editStatusReason(promoIncreaseObject.id, promoIncreaseObject);
    } else {
      createNewStatusReason(promoIncreaseObject);
    }
  };

  const exportDataStatusReason = async () => {
    setIsLoading(true);
    userStatusReason.exportDataStatusReason(tenant).then((response: any) => {
      setIsLoading(false);
      const filename =
        response.headers["content-disposition"].split("filename=")[1];
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, filename);
    });
  };

  const getStatusReasons = () => {
    setIsLoading(true);
    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        const startRow = params.request.startRow ? params.request.startRow : 0;
        const endRow = params.request.endRow;
        let pageSize = 10;
        if (
          endRow !== null &&
          endRow !== undefined &&
          startRow !== null &&
          startRow !== undefined
        ) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize;
        userStatusReason
          .getStatusReasons(tenant, pageNumber, pageSize)
          .then((response: any) => {
            params.successCallback(
              managerData(response),
              response.data.totalElements
            );
            setLength(response.data.totalElements);
            
            setIsLoading(false);
          })
          .catch((error: any) => {
            if (error.response) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: error.response.data.error,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else if (error.request) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: t("networkErrorMessage"),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else {
              setIsLoading(false);
            }
            setIsLoading(false);
          });
      },
    };
  };

  const getByCodeStatusReason = (code: string) => {
    return new Promise((resolve, reject) => {
      userStatusReason
        .getByCodeStatusReasons(tenant, code)
        .then((res) => {
          if (res) {
            resolve(false);
          } else {
            resolve(true);
          }
        })
        .catch((error) => {
          if (error.response) {
            resolve(true);
          }
        });
    });
  };
  const createNewStatusReason = (
    valuesStatusReasonObject: ValuesStatusReasonObject
  ) => {
    userStatusReason
      .createStatusReason(tenant, valuesStatusReasonObject)
      .then((response: any) => {
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t("statusReason.createActionSuccessMessage"),
              type: snackbarTypes.success,
              show: true,
              autoClose: true,
            },
          },
        });
        setRefreshTableByX(!refreshTableByX);
        setIsLoading(false);
      })
      .catch((error: any) => {
        if (error.response) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: error.response.data.msg,
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
        } else if (error.request) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("networkErrorMessage"),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
        } else {
        }
        setIsLoading(false);
      });
  };

  const editStatusReason = (
    id: any,
    valuesStatusReasonObject: ValuesStatusReasonObject
  ) => {
    userStatusReason
      .editStatusReason(tenant, id, valuesStatusReasonObject)
      .then((response: any) => {
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t("statusReason.editActionSuccessMessage"),
              type: snackbarTypes.success,
              show: true,
              autoClose: true,
            },
          },
        });
        setRefreshTableByX(!refreshTableByX);
        setIsLoading(false);
      })
      .catch((error: any) => {
        if (error.response) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: error.response.data.msg,
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
        } else if (error.request) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("networkErrorMessage"),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
        } else {
        }
        setIsLoading(false);
      });
  };

  function managerData(response: any) {
    let rows: any[] = [];
    response.data.content.forEach((element: any) => {
      let row = {
        code: element.code,
        descr: element.descr,
        status: element.status,
        default: element.default,
        valid: element.valid,
        id: element.id,
        transferable: element.transferable,
        damages: element.damages,
      };
      rows.push(row);
    });
    return rows;
  }

  const deleteSelectedStatusReason = (id: any) => {
    setIsLoading(true);
    userStatusReason
      .deleteStatusReason(tenant, id)
      .then(() => {
        setLength(length - 1);
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t("statusReason.deleteActionSuccessMessage", {
                idForDelete: getIdForDelete.code,
              }),
              type: snackbarTypes.success,
              show: true,
              autoClose: true,
            },
          },
        });
        setIsLoading(false);
        setRefreshTableByX(!refreshTableByX);
      })

      .catch((error: any) => {
        if (error.response) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("statusReason.messageForTimeout", {
                  idForDelete: getIdForDelete.code,
                }),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
          setIsLoading(false);
        }
        setIsLoading(false);
      });
  };

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  const onClickDelete = () => {
    deleteSelectedStatusReason(getIdForDelete.id);
    setOpen(false);
  };
  const onClickCloseDialog = () => setOpen(false);
  const onClickAddDialog = () => {
    setOpenAddDialog(true);
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(getStatusReasons());
    }
  }, [tenant, gridApi, refreshTableByX]);

  const searchStatusReason = (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setRefreshTableByX(!refreshTableByX);
  };
  const onResetTenant = () => {
    setRefreshTableByX(!refreshTableByX);
  };

  return (
    <>
      <SectionHeader
        title={
          t("statusReason.titleFirst") + " " + t("statusReason.titleSecond")
        }
      />
      {options.length > 1 && (
        <form
          id="idStatusReasonForm"
          onSubmit={(e: React.ChangeEvent<HTMLFormElement>) =>
            searchStatusReason(e)
          }
        >
          <GenericFilterBox
            formId="idStatusReasonForm"
            onReset={onResetTenant}
          ></GenericFilterBox>
        </form>
      )}
      <Box className="carGenericOuterTableBox">
        <Box>
          <Card>
            <Box
              minHeight={46}
              pr={1}
              display="flex"
              justifyContent={"flex-end"}
              alignItems="center"
            >
              <Tooltip title={t("tooltipTitle.download")}>
                <IconButton
                  color="accent"
                  disabled={length === 0 ? true : false}
                  onClick={exportDataStatusReason}
                >
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>

              {hasScope("SCOPE_CREATE_MDVEHICLE_STATUSREASON") && (
                <Tooltip title={t("tooltipTitle.add")}>
                  <IconButton color="accent" onClick={onClickAddDialog}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Card>
        </Box>

        <Box>
          <AgGridOperationTable
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            cacheBlockSize={pageSize}
            serverSideInfiniteScroll={true}
            rowModelType={"serverSide"}
            totalElements={length}
            emptyState={{
              title: t("emptyStateGrid.title"),
              content: t("emptyStateGrid.content")
            }}
          />



          {loading && <CustomLoader loading={loading} />}
          {openAddDialog && (
            <AddNewStatusReasons
              openAddDialog={openAddDialog}
              setOpenAddDialog={setOpenAddDialog}
              createNewStatusReason={createNewStatusReason}
              getByCodeStatusReason={getByCodeStatusReason}
              createOrEditStatusReason={createOrEditStatusReason}
              setStatusReasonDataForm={setStatusReasonDataForm}
              getStatusReasonDataForm={getStatusReasonDataForm}
            />
          )}

          <Dialog
            open={open}
            PaperProps={{
              sx: {
                minWidth: "600px !important",
                minHeight: "194px",
                borderRadius: "4px",
              },
            }}
          >
            <DialogTitle>
              <Grid
                container
                direction="row"
                alignItems="flex-start"
                justifyContent={"center"}
              >
                <Grid xs item>
                  <Stack direction="row" alignItems="center" gap={1}>
                    <InfoIcon sx={{ color: "#C8017D" }} fontSize="small" />
                    <Box>{t("statusReason.deleteModal.title")}</Box>
                  </Stack>
                </Grid>
                <Grid
                  xs
                  item
                  sx={{
                    justifyContent: "flex-end",
                    display: "flex",
                  }}
                >
                  <CloseIcon
                    color="disabled"
                    fontSize="small"
                    onClick={onClickCloseDialog}
                  />
                </Grid>
              </Grid>
            </DialogTitle>

            <DialogContent>
              <DialogContentText>
                {t("statusReason.deleteModal.bodyMessage", {
                  idForDelete: getIdForDelete.code,
                })}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Stack direction="row" spacing={2} p={1} mr={1}>
                <Button
                  sx={{
                    maxWidth: "111px",
                    maxHeight: "48px",
                    minWidth: "111px",
                    minHeight: "48px",
                  }}
                  variant="outlined"
                  onClick={onClickCloseDialog}
                >
                  <Typography
                    sx={{
                      textTransform: "capitalize",
                      fontWeight: 700,
                      lineHeight: 2.25,
                      color: "#C8017D",
                    }}
                    variant="subtitle1"
                  >
                    {t("actionButtons.cancel")}
                  </Typography>
                </Button>

                <Button
                  sx={{
                    maxWidth: "111px",
                    maxHeight: "48px",
                    minWidth: "111px",
                    minHeight: "48px",
                  }}
                  variant="contained"
                  color="accent"
                  onClick={onClickDelete}
                >
                  <Typography
                    sx={{
                      textTransform: "capitalize",
                      fontWeight: 700,
                      lineHeight: 2.25,
                      color: "white",
                    }}
                    variant="subtitle1"
                  >
                    {t("actionButtons.confirm")}
                  </Typography>
                </Button>
              </Stack>
            </DialogActions>
          </Dialog>
        </Box>
      </Box>
    </>
  );
};
